import { render, staticRenderFns } from "./PJProposalOverview.vue?vue&type=template&id=8b05f9a0"
import script from "./PJProposalOverview.vue?vue&type=script&lang=js"
export * from "./PJProposalOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports